/* import __COLOCATED_TEMPLATE__ from './fin-section-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import type AppService from 'embercom/services/app-service';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type RouterService from '@ember/routing/router-service';

interface Args {}

export default class FinSectionBanner extends Component<Args> {
  @service declare appService: AppService;
  @service declare intercomEventService: $TSFixMe;
  @service declare router: RouterService;

  get location(): string {
    return this.router.currentRouteName || '';
  }

  get shouldShowBanner(): boolean {
    return (
      this.appService.app.isEligibleForFinIncentiveOffer &&
      this.appService.app.canSeeFinIncentiveOffer &&
      this.appService.app.currentAdmin.canAccessBillingSettings
    );
  }

  @action
  onCtaClick() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'fin_section_banner_cta',
      place: this.location,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'IncentiveOffer::Banners::FinSectionBanner': typeof FinSectionBanner;
    'incentive-offer/banners/fin-section-banner': typeof FinSectionBanner;
  }
}
